import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserModifyAddRolesComponent } from "./user-modify-add-roles/user-modify-add-roles.component";

@Component({
	selector: "caass-user-modify-roles",
	templateUrl: "./user-modify-roles.component.html",
	styleUrls: ["./user-modify-roles.component.css"],
})
export class UserModifyRolesComponent implements OnInit {
	constructor(private dialogService: DialogService) {}

	ngOnInit(): void {
		this.SchoolRoleData = new Map<any, any>();
	}

	ngOnChanges() {
		// console.log("Role Changed");
		// console.log(this.lstSchool);

		//
		// Init schools that were added
		//
		this.lstSchool.forEach((school) => {
			if (!this.SchoolRoleData.has(school)) {
				this.SchoolRoleData.set(school, []);
			}
		});

		//
		// Remove schools that were removed
		//
		this.SchoolRoleData.forEach((value, key) => {
			if (this.lstSchool.indexOf(key) == -1) {
				this.SchoolRoleData.delete(key);
			}
		});

		if (this.lstSchool.length > 0) {
			this.School = this.lstSchool[0];
			this.lstRoles = this.SchoolRoleData.get(this.School);
			this.SelectedRoles = [];
		} else {
			this.School = null;
			this.lstRoles = [];
			this.SelectedRoles = [];
		}
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	@Input() UserLevelID: any;

	School: any;
	@Input() lstSchool: any = [];
	@Input() Processing: any;

	SchoolRoleData: Map<any, any> = new Map<any, any>();

	SelectedRoles: any = [];
	lstRoles: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "RoleDesc", header: "User Role" },
		{ field: "UserLevelDesc", header: "User Level" },
	];

	errorMessage: any = "";

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onRemove() {
		this.errorMessage = "";

		this.lstRoles = this.lstRoles.filter((role) => this.SelectedRoles.indexOf(role) == -1);
		this.SelectedRoles = [];

		this.SchoolRoleData.set(this.School, this.lstRoles);
	}
	onAdd() {
		this.errorMessage = "";

		if (this.School == null) {
			this.errorMessage = "Select a school";
			return;
		}

		var ref = this.dialogService.open(UserModifyAddRolesComponent, {
			header: "Add Roles",
			width: "fit-content",
			data: {
				UserLevelID: this.UserLevelID,
				SchoolID: this.School.SchoolID,
				SelectedRoles: this.lstRoles,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0 && response != undefined) {
				var lstToAdd = response;

				for (var z = 0; z < lstToAdd.length; z++) {
					var toAdd = lstToAdd[z];

					var found = false;
					for (var i = 0; i < this.lstRoles.length; i++) {
						var next = this.lstRoles[i];

						if (toAdd.RoleID == next.RoleID) {
							found = true;
						}
					}

					if (!found) {
						this.lstRoles = [...this.lstRoles, toAdd];
					}
				}

				this.SchoolRoleData.set(this.School, this.lstRoles);
			}
		});
	}

	onCopyAll() {
		console.log(this.SchoolRoleData);

		var lstRoles = this.SchoolRoleData.get(this.School);

		this.SchoolRoleData.forEach((val, key, map) => {
			this.SchoolRoleData.set(key, lstRoles);
		});
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	onSchoolChange(val) {
		this.errorMessage = "";

		//Change schools
		this.School = val;

		//Load data for new school
		this.lstRoles = this.SchoolRoleData.get(this.School);
		this.SelectedRoles = [];
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////

	UpdateAllRoles() {}

	///////////////////////////////////////////////////////
}
